export default __webpack_public_path__ + "static/media/errpage-404.fcdde306.svg";